export const RoutesPaths = {
  LOGIN: "/",
  SIGNUP: "/signup",
  FORGOTPASSWORD: "/forgot-password",
  VERIFYOTP: "/verify-otp",
  RESETPASSWORD: "/reset-password/:token",
  DASHBOARD: "/dashboard",
  COMPLETEPROFILE: "/complete-profile",
  INQUIRIES: "/inquiries",
  ORDER: "/order",
  MESSAGE: "/message",
  SETTING: "/setting",
  TRANSACTIONS: "/transactions",
  DOCUMENT: "/document",
  INQUIRIESDETAILS: "/inquiries/:id",
  ORDERDETAILS: "/order/:id",
  PRODUCT: "/product",
  ADDPRODUCT: "/add-product",
  VIEWPRODUCT: "/product/view/:id",
  EDITPRODUCT: "/product/edit/:id",
  QUIMERA_ORDERS: "/quimera-orders",
  QUIMERA_ORDER_DETAILS: "/quimera-orders/:id",
};

const apiUrl = process.env.REACT_APP_API_URL?.trim().replace(/\/+$/, "");
const imageUrl = process.env.REACT_APP_API_IMAGE_URL?.trim().replace(/\/+$/, "");

if (!apiUrl) {
  throw new Error(
    "REACT_APP_API_URL is missing. Add it to .env and restart the development server.",
  );
}

export const backendUrl = `${apiUrl}/api`;
export const backendImageUrl = imageUrl;
const quimeraApiUrl = (process.env.REACT_APP_QUIMERA_API_URL || "").trim();
const quimeraSiteUrl = (process.env.REACT_APP_QUIMERA_SITE_URL || "").trim();
export const quimeraUrl = (quimeraApiUrl || quimeraSiteUrl).replace(/\/+$/, "");
export const quimeraUsername = process.env.REACT_APP_QUIMERA_USERNAME || "";
export const quimeraPassword = process.env.REACT_APP_QUIMERA_PASSWORD || "";
